import { render, staticRenderFns } from "./pieChart3.vue?vue&type=template&id=31f9d25e&"
import script from "./pieChart3.vue?vue&type=script&lang=js&"
export * from "./pieChart3.vue?vue&type=script&lang=js&"
import style0 from "./pieChart3.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports